import React from "react";
import { Col, Row } from "reactstrap";
import { useSelector } from "react-redux";
import lodash, { uniqueId } from "lodash";
import PerfectScrollbar from "react-perfect-scrollbar";
import reactStringReplace from "react-string-replace";

import { SpeakerColorScheme } from "../../../constants";
import SpeakerIcon from "./SpeakerIcon";
import DownloadSpeakerPDF from "./DownloadSpeakerPDF";

const transcriptType = (
  transcript,
  checked,
  search,
  video,
  handlePlayVideoSentence,
  productName,
  brandName,
  showTimestamp = false
) => {
  const completeTranscript = useSelector(
    (state) => state.videoAssociations.transcript
  );

  if (search) {
    return lodash.size(transcript.transcription) !== 0
      ? transcript.transcription
          .filter((x) => {
            if (checked) {
              return new RegExp(search, "i").test(x.content);
            }
            return x.content;
          })
          .map((row, i) => {
            const transcriptSentence = reactStringReplace(
              row.content,
              search,
              (match) => <span className="highlightSearchedWord">{match}</span>
            );

            return (
              <div key={uniqueId()} className="transcript-sentence align-middle">
                <Row>
                  <Col lg={2}>{i + 1}.</Col>
                  <Col lg={1}>
                    <img
                      src={
                        require(`@src/assets/images/vyrill/reports/play-circle.svg`)
                          .default
                      }
                      width={25}
                      aria-label="play"
                      role="button"
                      onClick={handlePlayVideoSentence(
                        video._id,
                        row.start_time
                      )}
                    />
                  </Col>
                  <Col lg={9}>{transcriptSentence}</Col>
                </Row>
              </div>
            );
          })
      : "No Transcript Found";
  }
  return video.transcription_text
    ? completeTranscript.map(({ start_time, content, speaker }, i, array) => {
        let replacedText;
        replacedText = reactStringReplace(content, brandName, (match) => (
          <span className="highlightBrandWord"key={uniqueId()}>{match}</span>
        ));

        productName?.forEach(
          (element) =>
            (replacedText = reactStringReplace(
              replacedText,
              element.name,
              (match) => (
                <span key={uniqueId()} className="highlightProductWord">
                  {match}
                </span>
              )
            ))
        );

        if (i === 0 || speaker !== array[i - 1].speaker) {
          return (
            <div
            key={uniqueId()}
              className="transcript-sentence d-flex gap-3"
              style={i === 0 ? {} : { marginTop: "30px" }}
            >
              <div
                style={{ minWidth: "100px", paddingTop: "-2px" }}
                className="d-flex flex-column text-center align-items-center"
              >
                {/* speaker */}
                <SpeakerIcon
                  circleColor={SpeakerColorScheme[speaker][0]}
                  pathColor={SpeakerColorScheme[speaker][1]}
                />
                <span style={{ fontSize: "10px", color: "#666179" }}>
                  Speaker {speaker + 1}
                </span>
              </div>
              {showTimestamp && (
                <div
                  style={{
                    minWidth: "70px",
                    paddingTop: "8px",
                    color: "#6B727A",
                    fontSize:'16px'
                  }}
                >
                  {start_time}
                </div>
              )}
              <div
                style={{
                  lineHeight: "40px",
                  color: "#000000",
                  fontSize:'16px'
                }}
              >
                {replacedText}
              </div>
            </div>
          );
        } else {
          return (
            <div key={uniqueId()} className="transcript-sentence d-flex gap-3">
              <div style={{ minWidth: "100px" }}></div>
              {showTimestamp && (
                <div
                  style={{
                    minWidth: "70px",
                    color: "#6B727A",
                    marginTop: "6px",
                  }}
                >
                  {start_time}
                </div>
              )}
              <div style={{ lineHeight: "40px", color: "#000000", fontSize:'16px' }}>
                {replacedText}
              </div>
            </div>
          );
        }
      })
    : "No Transcript Found";
};

const TranscriptTab = ({
  video,
  transcript,
  checked,
  search = "",
  handlePlayVideoSentence,
  productName,
  brandName,
  showTimestamp,
  componentRef,
}) => {
  const completeTranscript = useSelector(
    (state) => state.videoAssociations.transcript
  );
  
    return (
    <>
      <PerfectScrollbar
        className="main-menu-content"
        options={{ wheelPropagation: true }}
        // onScrollY={(container) => scrollMenu(container)}
        style={{ maxHeight: "450px", minScrollbarLength: 0, paddingRight:'40px' }}
      >
        {/* <div className="transcript-tab" style={search ? blockStyle : {}}> */}
        {transcriptType(
          transcript,
          checked,
          search,
          video,
          handlePlayVideoSentence,
          productName,
          brandName,
          showTimestamp
        )}
        {/* </div> */}
      </PerfectScrollbar>
       <div style={{ display: "none" }}>
        <DownloadSpeakerPDF
          transcript={transcript}
          checked={checked}
          search={search}
          video={video}
          handlePlayVideoSentence={handlePlayVideoSentence}
          productName={productName}
          brandName={brandName}
          showTimestamp={showTimestamp}
          componentRef={componentRef}
          completeTranscript={completeTranscript}
        />
      </div> 
    </>
  );
};

export default TranscriptTab;
